import { useEffect } from 'react';
import { Axios } from '../../api';
import store from '../../redux/store';
import { login } from '../../redux/slices/userSlice';
import { getAuthUser, setToken, getToken } from '../../utils';

const BaseApi = () => {

    useEffect(() => {
        if (getAuthUser()) {
            fetchUserData();
        }
    }, []);

    const fetchUserData = async () => {
        try {
            const res = await Axios.get("api/user/update-profile");
            const updatedUser = res.data.payload;

            // update localStorage — keep the existing token, refresh the user object
            setToken({ access_token: getToken(), user: updatedUser });

            // update Redux store
            store.dispatch(login(updatedUser));
        } catch (e) {
            console.error("Failed to fetch user data", e);
        }
    };

    return null;
};

export default BaseApi;
